class CollectionTabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = Array.from(this.querySelectorAll('[data-tab-trigger]'));
    this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
    this.prevButton = this.querySelector('[data-carousel-prev]');
    this.nextButton = this.querySelector('[data-carousel-next]');
    this.activeSwiperEl = null;
  }

  connectedCallback() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.handleTabClick);
      tab.addEventListener('keydown', this.handleTabKeydown);
    });
    this.prevButton?.addEventListener('click', this.handlePrevClick);
    this.nextButton?.addEventListener('click', this.handleNextClick);

    const initialPanel = this.panels.find((panel) => !panel.hidden);
    if (initialPanel) this.activateCarousel(initialPanel);
  }

  disconnectedCallback() {
    this.tabs.forEach((tab) => {
      tab.removeEventListener('click', this.handleTabClick);
      tab.removeEventListener('keydown', this.handleTabKeydown);
    });
    this.prevButton?.removeEventListener('click', this.handlePrevClick);
    this.nextButton?.removeEventListener('click', this.handleNextClick);
  }

  handleTabClick = (event) => {
    const tab = event.currentTarget;
    if (tab.getAttribute('aria-selected') === 'true') return;
    this.selectTab(tab);
  };

  handleTabKeydown = (event) => {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    if (currentIndex === -1) return;

    let newIndex = null;
    if (event.key === 'ArrowRight') {
      newIndex = (currentIndex + 1) % this.tabs.length;
    } else if (event.key === 'ArrowLeft') {
      newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    } else if (event.key === 'Home') {
      newIndex = 0;
    } else if (event.key === 'End') {
      newIndex = this.tabs.length - 1;
    }

    if (newIndex === null) return;

    event.preventDefault();
    const nextTab = this.tabs[newIndex];
    nextTab.focus();
    this.selectTab(nextTab);
  };

  selectTab(tab) {
    const panelId = tab.getAttribute('aria-controls');
    const panel = this.querySelector(`#${CSS.escape(panelId)}`);
    if (!panel) return;

    this.tabs.forEach((t) => {
      const isSelected = t === tab;
      t.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      t.tabIndex = isSelected ? 0 : -1;
    });

    this.panels.forEach((p) => {
      p.hidden = p !== panel;
    });

    this.activateCarousel(panel);
  }

  activateCarousel(panel) {
    const swiperEl = panel.querySelector('swiper-container');
    if (!swiperEl) return;

    if (!swiperEl.swiper) {
      swiperEl.initialize();
      swiperEl.swiper.on('slideChange', this.updateArrowState);
    }

    this.activeSwiperEl = swiperEl;
    this.updateArrowState();
  }

  updateArrowState = () => {
    const swiper = this.activeSwiperEl?.swiper;
    if (!swiper) return;

    this.prevButton?.setAttribute('aria-disabled', swiper.isBeginning);
    this.nextButton?.setAttribute('aria-disabled', swiper.isEnd);
  };

  handlePrevClick = () => {
    this.activeSwiperEl?.swiper?.slidePrev();
  };

  handleNextClick = () => {
    this.activeSwiperEl?.swiper?.slideNext();
  };
}

customElements.define('collection-tabs', CollectionTabs);
